export const portalNotice = {
    "title": "Note regarding the online portal",
    "intro": "Our 3D printing configurator has moved. Private customers can continue to place orders here and use their accounts as usual. We kindly ask business customers to re-register on the new site and submit their 3D printing orders here:",
    "cta": "To the new 3D printing configurator",
    "thanks": "Thank you for your understanding!",
    "benefits": "Benefit from a wide range of post-processing options, easy reordering, convenient delivery dates with express, economy or standard production, and much more."
};
